@if (isOneTimeCustomer()) {
  <div class="sales-onetime-hint" data-testid="one-time-customer-hint">
    <soft-ds-icon name="fa-regular fa-circle-info" size="xs" />
    <span class="ds-body-2">
      Barverkaufskunde — Sammelkonto für Laufkundschaft. Kreditlimit wird dafür nicht ausgewertet.
    </span>
  </div>
} @else {
  <div class="sales-collapsible" [class.is-open]="expanded()">
    <button type="button" class="sales-collapsible__head" (click)="toggle()">
      <span
        class="sales-card-icon sm"
        [class.is-warning]="creditView()?.level === 'warning'"
        [class.is-danger]="creditView()?.level === 'limit'"
      >
        <soft-ds-icon name="fa-regular fa-coins" size="xs" />
      </span>
      <span class="flex-1 ds-body-2-semibold text-left">Kreditlimit</span>
      @if (creditLevelBadge(); as badge) {
        <soft-ds-badge size="sm" [variant]="badge.variant">
          <soft-ds-icon [name]="badge.icon" size="xs" />
          {{ badge.label }}
        </soft-ds-badge>
      }
      <soft-ds-icon
        name="fa-regular fa-chevron-right"
        size="xs"
        class="sales-chevron"
        [class.is-open]="expanded()"
      />
    </button>
    @if (expanded()) {
      <div class="sales-collapsible__body">
        @if (creditView(); as credit) {
          <div class="flex items-baseline justify-between mb-3">
            <span class="ds-body-2 text-light">
              {{ credit.currentDocumentBalance !== null ? 'Saldo Kunde' : 'Offener Saldo' }}
            </span>
            <span class="ds-heading-6-semibold">
              @if (credit.balance !== null) {
                {{ credit.balance | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-AT' }}
              } @else {
                —
              }
            </span>
          </div>

          <div class="sales-credit-rows">
            @if (credit.currentDocumentBalance !== null) {
              <div class="sales-row">
                <span class="sales-row__label">Aktueller Beleg</span>
                <span class="sales-row__value">
                  {{ credit.currentDocumentBalance | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-AT' }}
                </span>
              </div>
              <div class="sales-row sales-row--total">
                <span class="sales-row__label">Gesamt</span>
                <span class="sales-row__value">
                  {{ credit.total | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-AT' }}
                </span>
              </div>
            } @else {
              @if (credit.due) {
                <div class="sales-row">
                  <span class="sales-row__label">Offene Posten fällig</span>
                  <span class="sales-row__value">
                    {{ credit.due | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-AT' }}
                  </span>
                </div>
              }
              @if (credit.unpaid) {
                <div class="sales-row">
                  <span class="sales-row__label">Offene Posten nicht fällig</span>
                  <span class="sales-row__value">
                    {{ credit.unpaid | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-AT' }}
                  </span>
                </div>
              }
              @for (row of credit.documentBalance; track row.label) {
                <div class="sales-row">
                  <span class="sales-row__label">{{ row.label }}</span>
                  <span class="sales-row__value">
                    {{ row.value | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-AT' }}
                  </span>
                </div>
              }
            }
          </div>

          <div class="flex gap-2.5 mt-3">
            <div class="sales-box">
              <div class="sales-box__label ds-caption text-light">
                <soft-ds-icon name="fa-regular fa-credit-card" size="xs" />
                Kreditrahmen 1
              </div>
              <div class="sales-box__value">
                @if (credit.warning !== null) {
                  {{ credit.warning | currency: 'EUR' : 'symbol' : '1.0-0' : 'de-AT' }}
                } @else {
                  —
                }
              </div>
            </div>
            <div class="sales-box">
              <div class="sales-box__label ds-caption text-light">
                <soft-ds-icon name="fa-regular fa-credit-card" size="xs" />
                Kreditrahmen 2
              </div>
              <div class="sales-box__value">
                @if (credit.limit !== null) {
                  {{ credit.limit | currency: 'EUR' : 'symbol' : '1.0-0' : 'de-AT' }}
                } @else {
                  —
                }
              </div>
            </div>
          </div>
        } @else if (creditLoading()) {
          <div class="flex flex-col gap-2">
            <soft-loading-skeleton height="20px" width="60%" />
            <soft-loading-skeleton height="46px" />
          </div>
        } @else {
          <span class="ds-body-2 text-light">Keine Kreditdaten verfügbar</span>
        }
      </div>
    }
  </div>
}
